import Decimal from "decimal.js"
import PropTypes from "prop-types"
import React from "react"

import Table from "src/components/Table"
import Tooltip from "src/components/Tooltip"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const TaxCell = ({
  taxRate,
  taxAmount,
  taxes,
  currency,
  unwrapped = false,
}) => {
  const cellTitle = (combinedTaxRate) => {
    const combinedRateDisplay = `${new Decimal(combinedTaxRate)
      .mul(100)
      .toFixed(4)
      .replace(/\.?0+$/, "")}%`

    if (taxAmount !== undefined) {
      return `${formatCurrencyFromMinorUnits({
        amount: taxAmount,
        currency,
      })} (${combinedRateDisplay})`
    }
    return combinedRateDisplay
  }

  const getCombinedTaxRate = () => {
    if (taxRate !== undefined && taxRate !== null) {
      return taxRate
    } else if (!taxes || taxes.length === 0) {
      return 0
    } else {
      // Itemized taxes with at least one tax
      return taxes
        .reduce((sum, tax) => sum.add(new Decimal(tax.rate)), new Decimal(0))
        .toNumber()
    }
  }

  const breakdownText =
    taxes?.length >= 1 ? (
      <div className="text-left">
        {taxes.map((tax) => (
          <div key={tax.id}>
            {tax.name}: {tax.rate_display}
          </div>
        ))}
      </div>
    ) : null

  if (breakdownText) {
    const content = (
      <span className="inline-flex items-center gap-1 whitespace-nowrap">
        {cellTitle(getCombinedTaxRate())}
        <Tooltip text={breakdownText} placement="top" variant="dark">
          <i className="fa-kit fa-md-info text-bold -mt-1 cursor-default text-base text-gray-600" />
        </Tooltip>
      </span>
    )

    return unwrapped ? content : <Table.Cell>{content}</Table.Cell>
  } else {
    const title = cellTitle(getCombinedTaxRate())
    return unwrapped ? <span title={title} /> : <Table.Cell title={title} />
  }
}

TaxCell.propTypes = {
  taxRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  taxAmount: PropTypes.number,
  taxes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      rate: PropTypes.number.isRequired,
      rate_display: PropTypes.string.isRequired,
    })
  ),
  currency: PropTypes.string.isRequired,
  unwrapped: PropTypes.bool,
}

export default TaxCell
